angular.module('aprima-core-ui').directive('apRequired', ['MetadataService', '_', '$controller', function (MetadataService, _, $controller) {
    'use strict';
    //Dynamically applies required validation logic based on values in $scope.metadata.
    //adapted from the ngRequired directive.

    function link(scope, elm, attrs, ctrl) {
        if (!ctrl || !ctrl.ngModel) return;
        var modelCtrl = ctrl.ngModel;

        var fieldId = attrs.name;
        var formGroup = ctrl.apFormGroup ?
            ctrl.apFormGroup.formGroup :
            $controller('ApFormGroupCtrl', {
                $scope: scope,
                $element: getFormGroup(elm)
            }).init(fieldId);
        formGroup.addField(fieldId, modelCtrl, elm);

        var apRequiredExpr = false;

        var elementWatches = [];
        var metadataWatches = [];

        function validator(modelValue, viewValue) {
            var metadata = scope.metadata;
            var value = modelValue || viewValue;

            var isRequired = apRequiredExpr;
            //if nothing was passed into this ap-required, then look at the metadata
            if (metadata && _.isUndefined(isRequired)) {
                isRequired = getIsRequired(metadata, scope);
            }
            formGroup.setFieldRequired(fieldId, isRequired);

            var invalid = isRequired && modelCtrl.$isEmpty(value);

            return !invalid;
        }

        modelCtrl.$validators.required = validator;

        var baseModel = attrs.ngModel.split('.');
        baseModel.pop();
        baseModel = baseModel.join('.');

        //This will trigger when apRequired attribute value changes
        //newVal will have the value of the attribute evaluated with the scope
        //this is the kind of watch that ng-required does
        //the only difference is that ng-required actually watches the value of 'ng-required',
        //then uses it to update 'required', and then another
        //directive $observe's the value in 'required' and validates when that gets updated
        elementWatches.push(scope.$watch(attrs.apRequired, function (newVal) {
            if(apRequiredExpr !== newVal) {
                //nothing is passed into ap-required, so watch the metadata to see when to update validation
                if(_.isUndefined(newVal)) {
                    addMetadataWatches();
                }
                //an expression is passed into ap-required, so don't watch the metadata and clear out any current watchers
                else {
                    clearMetadataWatches();
                }
            }
            apRequiredExpr = newVal;
            modelCtrl.$validate();
        }));

        scope.$on('$destroy', function () {
            elementWatches.forEach(function(watchRemover) {
                watchRemover();
            });
            clearMetadataWatches();
            formGroup.removeField(fieldId);
        });

        function addMetadataWatches() {
            //only triggers when metadata reference changes
            //but will add watches for the validation group fields too
            metadataWatches.push(scope.$watch('metadata', function (newValue) {
                modelCtrl.$validate();

                if(newValue){
                    var metadataObj = newValue.Fields;
                    var modelField = attrs.ngModel.split('.');
                    modelField = modelField[modelField.length - 1];

                    var fieldMetaData = metadataObj[modelField];

                    if(fieldMetaData && fieldMetaData.IsGroupRequired){
                        for(var i in metadataObj){
                            if(newValue.Fields[i].ValidationGroup === fieldMetaData.ValidationGroup){
                                metadataWatches.push(scope.$watch(baseModel + '.' + newValue.Fields[i].FieldName, modelCtrl.$validate));
                            }
                        }
                    }
                }
            }));
        }

        function clearMetadataWatches() {
            if(!_.isEmpty(metadataWatches)) {
                metadataWatches.forEach(function(watchRemover) {
                    watchRemover();
                });
                metadataWatches.length = 0;
            }
        }

        function getIsRequired(metadata, scope) {
            var obj = MetadataService.getObjectFromMetadata(metadata, attrs);
            if (obj) {
                if(obj.IsGroupRequired){
                    for(var i in metadata.Fields){
                        if(metadata.Fields[i].IsGroupRequired && metadata.Fields[i].ValidationGroup === obj.ValidationGroup){
                            var propertyValue = scope.$eval(baseModel + '.' + metadata.Fields[i].FieldName);

                            if(propertyValue){
                                return true;
                            }
                        }
                    }
                }

                return obj.IsRequired;
            }

            return false;
        }
    }

    function getFormGroup (elem) {
        return elem.parents('.form-group').firstOrNull();
    }

    return {
        require: {
            ngModel: 'ngModel',
            apFormGroup: '?^^apFormGroup'
        },
        restrict: 'A',
        link: link
    };
}]);